import { useMemo } from "react";
import { useApi } from "./useApi";
import { toList } from "../lib/api";
import { levelOf } from "../context/AuthContext";

export const LEADER_STATS = [["ppg", "Points"], ["rpg", "Rebounds"], ["apg", "Assists"], ["spg", "Steals"], ["bpg", "Blocks"]];
const MIN_GP = 3;

/** {player_id: [{key, label, value}]}: per-game leaders within each level (Varsity/JV), 3+ games, ties share the badge. */
export const leaderBadges = (rows, players) => {
  const level = new Map(players.map((p) => [p.id, levelOf(p)]));
  const out = {};
  ["varsity", "jv"].forEach((lv) => {
    const pool = rows.filter((r) => level.get(r.player_id) === lv && (r.gp ?? 0) >= MIN_GP);
    LEADER_STATS.forEach(([k, label]) => {
      const top = Math.max(0, ...pool.map((r) => Number(r[k]) || 0));
      if (top <= 0) return;
      pool.filter((r) => Number(r[k]) === top).forEach((r) => { out[r.player_id] = [...(out[r.player_id] ?? []), { key: k, label, value: top }]; });
    });
  });
  return out;
};

/** Loads the roster (unless passed in) and team stats, and returns leader badges per player. */
export function useLeaders(tid, players) {
  const roster = useApi(tid && !players && `/teams/${tid}/players`);
  const stats = useApi(tid && `/teams/${tid}/stats/team`);
  return useMemo(() => leaderBadges(toList(stats.data, ["players"]), players ?? toList(roster.data, ["players"])), [stats.data, players, roster.data]);
}
